module.exports = __webpack_public_path__ + "6115d420676bb62e6d41768d8c482996.pdf";